import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=06cd6204&scoped=true"
var script = {}
import style0 from "./Loader.vue?vue&type=style&index=0&id=06cd6204&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cd6204",
  null
  
)

export default component.exports